import { Injectable } from '@angular/core';
import { dacDocSubmissionInitialState, DacDocSubmissionStateProps } from './dac-doc-submission-state.store';
import { BaseStoreRepository } from '../base-store.repository';
import { select, Store } from '@ngneat/elf';

export type DacDocSubmissionStore = Store<
  {
    name: string;
    state: DacDocSubmissionStateProps;
    config: undefined;
  },
  DacDocSubmissionStateProps
>;

@Injectable({ providedIn: 'root' })
export class DacDocSubmissionRepositoryFactory {
  static create(store: DacDocSubmissionStore) {
    return new DacDocSubmissionRepository(store);
  }
}

export class DacDocSubmissionRepository extends BaseStoreRepository<DacDocSubmissionStateProps> {
  constructor(store: DacDocSubmissionStore) {
    super(store.pipe(select(state => state)), store, { ...dacDocSubmissionInitialState });
  }
}
